<p-dialog
    header="Registrar Contrato"
    [(visible)]="visible"
    [modal]="true"
    [closable]="true"
    [style]="{ width: '600px', maxHeight: '90%', height: '100%' }"
    (onHide)="closeDialog()"
>
    <div class="loading-spinner" *ngIf="isLoading">
        <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
    </div>

    <div *ngIf="!isLoading" class="row">
        <div class="column">
            <div class="field">
                <label for="typeContract" class="font-semibold">Tipo de Contrato</label>

                <p-autoComplete
                    id="typeContract"
                    [(ngModel)]="selectedTypeContract"
                    [suggestions]="filteredOptions"
                    (completeMethod)="filterOptions($event, 'typeContract')"
                    (input)="onChangeInput($event, 'typeContract')"
                    [dropdown]="true"
                    [forceSelection]="true"
                    [placeholder]="'Selecciona un tipo'"
                    (onSelect)="onSelect($event, 'typeContract')"
                    [style]="{ width: '100%', backgroundColor: 'white' }"
                    [field]="'text'"
                ></p-autoComplete>
            </div>

            <div class="calendar-row">
                <div class="calendar-item">
                    <label for="contractStartDate">Fecha de Inicio</label>

                    <p-calendar
                        id="contractStartDate"
                        [(ngModel)]="contractStartDate"
                        [icon]="'pi pi-pencil'"
                        [showIcon]="true"
                        dateFormat="dd/mm/yy"
                        placeholder="DD/MM/YYYY"
                        (ngModelChange)="onChangeInput($event, 'contractStartDate')"
                        (onBlur)="validateField('contractStartDate')"
                    ></p-calendar>
                </div>

                <div class="calendar-item">
                    <label for="contractEndDate">Fecha de Finalización</label>

                    <p-calendar
                        id="contractEndDate"
                        [(ngModel)]="contractEndDate"
                        [icon]="'pi pi-pencil'"
                        [showIcon]="true"
                        [minDate]="contractStartDate"
                        dateFormat="dd/mm/yy"
                        placeholder="DD/MM/YYYY"
                        (ngModelChange)="onChangeInput($event, 'contractEndDate')"
                        (onBlur)="validateField('contractEndDate')">
                    </p-calendar>
                </div>
            </div>

            <div class="field-container">
                <!-- Moneda -->
                <div class="field">
                    <label for="currency" class="font-semibold">Moneda</label>

                    <p-autoComplete
                        id="currency"
                        [(ngModel)]="selectedCurrency"
                        [suggestions]="filteredOptions"
                        (completeMethod)="filterOptions($event, 'currency')"
                        (input)="onChangeInput($event, 'currency')"
                        [dropdown]="true"
                        [forceSelection]="true"
                        [placeholder]="'Selecciona una moneda'"
                        (onSelect)="onSelect($event, 'currency')"
                        [style]="{ width: '100%', backgroundColor: 'white' }"
                        [field]="'text'"
                    ></p-autoComplete>

                    <div *ngIf="!selectedCurrency && hasInteracted['currency']" class="error-message">Este campo es obligatorio.</div>
                </div>

                <!-- Sueldo básico -->
                <div class="field">
                    <label for="basicSalary" class="font-semibold">Sueldo Básico</label>

                    <p-inputGroup>
                        <p-inputGroupAddon>
                            <span *ngIf="selectedCurrencyCode" class="phone-prefix">{{ selectedCurrencyCode }}</span>
                        </p-inputGroupAddon>

                        <p-inputNumber
                            id="basicSalary"
                            mode="decimal"
                            [minFractionDigits]="2"
                            [maxFractionDigits]="2"
                            [min]="0"
                            inputId="withoutgrouping"
                            [useGrouping]="false"
                            [(ngModel)]="basicSalary"
                            (ngModelChange)="onChangeInput($event, 'basicSalary')"
                            [placeholder]="'Ingresa sueldo básico'"
                        ></p-inputNumber>
                    </p-inputGroup>
                </div>
            </div>

            <div
                class="field-container"
                *ngIf="
                    selectedWorkingMode?.key == '1' || 
                    selectedWorkingMode?.key == '3'
                "
            >
                <!-- Bono de PC -->
                <div class="field">
                    <label for="computerAllowance" class="font-semibold">Bono de PC</label>

                    <p-inputGroup>
                        <p-inputGroupAddon>
                            <span *ngIf="selectedCurrencyCode" class="phone-prefix">{{ selectedCurrencyCode }}</span>
                        </p-inputGroupAddon>
                        <p-inputNumber
                            id="computerAllowance"
                            mode="decimal"
                            [minFractionDigits]="2"
                            [maxFractionDigits]="2"
                            [min]="0"
                            inputId="withoutgrouping"
                            [useGrouping]="false"
                            [(ngModel)]="computerAllowance"
                            (ngModelChange)="onChangeInput($event, 'computerAllowance')"
                            [placeholder]="'Ingresa bono de PC'"
                        ></p-inputNumber>
                    </p-inputGroup>

                    <div
                        *ngIf="!computerAllowance && hasInteracted['computerAllowance']"
                        style="color: red; font-size: 0.875rem; margin-top: 2px"
                    >
                        Este campo es obligatorio.
                    </div>
                </div>

                <!-- Bono de Internet -->
                <div class="field">
                    <label for="internetAllowance" class="font-semibold">Bono de Internet</label>

                    <p-inputGroup>
                        <p-inputGroupAddon>
                            <span *ngIf="selectedCurrencyCode" class="phone-prefix">{{ selectedCurrencyCode }}</span>
                        </p-inputGroupAddon>
                        <p-inputNumber
                            id="internetAllowance"
                            mode="decimal"
                            [minFractionDigits]="2"
                            [maxFractionDigits]="2"
                            [min]="0"
                            inputId="withoutgrouping"
                            [useGrouping]="false"
                            [(ngModel)]="internetAllowance"
                            (ngModelChange)="onChangeInput($event, 'internetAllowance')"
                            [placeholder]="'Ingresa bono de internet'"
                        ></p-inputNumber>
                    </p-inputGroup>

                    <div
                        *ngIf="!internetAllowance && hasInteracted['internetAllowance']"
                        style="color: red; font-size: 0.875rem; margin-top: 2px"
                    >
                        Este campo es obligatorio.
                    </div>
                </div>
            </div>

            <div
                class="field-container"
                *ngIf="
                    selectedWorkingMode?.key == '1' ||
                    selectedWorkingMode?.key == '2' ||
                    selectedWorkingMode?.key == '3'
                "
            >
                <!-- Bono de luz -->
                <div
                    class="field"
                    *ngIf="
                        selectedWorkingMode?.key == '1' || 
                        selectedWorkingMode?.key == '3'
                    "
                >
                    <label for="electricityAllowance" class="font-semibold">Bono de luz</label>

                    <p-inputGroup>
                        <p-inputGroupAddon>
                            <span *ngIf="selectedCurrencyCode" class="phone-prefix">{{ selectedCurrencyCode }}</span>
                        </p-inputGroupAddon>
                        <p-inputNumber
                            id="electricityAllowance"
                            mode="decimal"
                            [minFractionDigits]="2"
                            [maxFractionDigits]="2"
                            [min]="0"
                            inputId="withoutgrouping"
                            [useGrouping]="false"
                            [(ngModel)]="electricityAllowance"
                            (ngModelChange)="onChangeInput($event, 'electricityAllowance')"
                            [placeholder]="'Ingresa bono de luz'"
                        ></p-inputNumber>
                    </p-inputGroup>

                    <div
                        *ngIf="!electricityAllowance && hasInteracted['electricityAllowance']"
                        style="color: red; font-size: 0.875rem; margin-top: 2px"
                    >
                        Este campo es obligatorio.
                    </div>
                </div>

                <!-- Bono de Movilidad -->
                <div
                    class="field"
                    *ngIf="selectedWorkingMode?.key == '2' || selectedWorkingMode?.key == '3'"
                >
                    <label for="transportationAllowance" class="font-semibold">Bono de Movilidad</label>
                    
                    <p-inputGroup>
                        <p-inputGroupAddon>
                            <span *ngIf="selectedCurrencyCode" class="phone-prefix">{{ selectedCurrencyCode }}</span>
                        </p-inputGroupAddon>
                        <p-inputNumber
                            id="transportationAllowance"
                            mode="decimal"
                            [minFractionDigits]="2"
                            [maxFractionDigits]="2"
                            [min]="0"
                            inputId="withoutgrouping"
                            [useGrouping]="false"
                            [(ngModel)]="transportationAllowance"
                            (ngModelChange)="onChangeInput($event, 'transportationAllowance')"
                            [placeholder]="'Ingresa bono de movilidad'"
                        ></p-inputNumber>
                    </p-inputGroup>

                    <div
                        *ngIf="!transportationAllowance && hasInteracted['transportationAllowance']"
                        style="color: red; font-size: 0.875rem; margin-top: 2px"
                    >
                        Este campo es obligatorio.
                    </div>
                </div>
            </div>

            <div class="field-container">
                <!-- Bono de cumplimiento -->
                <div class="field">
                    <label for="performanceBonus" class="font-semibold">Bono Cumplimiento</label>

                    <p-inputGroup>
                        <p-inputGroupAddon>
                            <span *ngIf="selectedCurrencyCode" class="phone-prefix">{{ selectedCurrencyCode }}</span>
                        </p-inputGroupAddon>
                        <p-inputNumber
                            id="performanceBonus"
                            mode="decimal"
                            [minFractionDigits]="2"
                            [maxFractionDigits]="2"
                            [min]="0"
                            inputId="withoutgrouping"
                            [useGrouping]="false"
                            [(ngModel)]="performanceBonus"
                            (ngModelChange)="onChangeInput($event, 'performanceBonus')"
                            [placeholder]="'Ingresa bono'"
                        ></p-inputNumber>
                    </p-inputGroup>
                </div>

                <!-- Salario Total -->
                <div class="field">
                    <label for="salary" class="font-semibold">Salario Total</label>
                    
                    <p-inputGroup aria-disabled="true">
                        <p-inputGroupAddon>
                            <span *ngIf="selectedCurrencyCode" class="phone-prefix">{{ selectedCurrencyCode }}</span>
                        </p-inputGroupAddon>

                        <p-inputNumber
                            id="salary"
                            mode="decimal"
                            [minFractionDigits]="2"
                            [maxFractionDigits]="2"
                            [min]="0"
                            inputId="withoutgrouping"
                            [useGrouping]="false"
                            [(ngModel)]="salary"
                            [disabled]="true"
                            (ngModelChange)="onChangeInput($event, 'salary')"
                            [placeholder]="'0.00'"
                        ></p-inputNumber>
                    </p-inputGroup>

                    <div 
                        *ngIf="!salary && hasInteracted['salary']" 
                        style="color: red; font-size: 0.875rem; margin-top: 2px"
                    >
                        Este campo es obligatorio.
                    </div>
                </div>
            </div>

            <div class="field">
                <label for="confirmation">¿Proseguirá el empleado en la empresa?</label>

                <div *ngFor="let continue of continues" class="confirmation">
                    <p-checkbox 
                        [ngModel]="selectedContinuity?.key === continue.key"
                        inputId="confirmation-{{ continue.key }}" 
                        [label]="continue.text" 
                        [binary]="true" 
                        [value]="continue"
                        (onChange)="onCheckboxChange(continue)" />
                </div
                >
                <div *ngIf="!selectedContinuity && hasInteracted['continue']" class="error-message">
                    Este campo es obligatorio.
                </div>
            </div>

            <div class="field">
                <label for="selectedFileName" class="font-semibold">Subir contrato</label>

                <div
                    class="file-container"
                    (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)"
                    (drop)="onDrop($event)"
                >
                    <div class="file-preview" (click)="openFileUpload('pdf')">
                        <div class="custom-file-display">
                            <div class="custom-file-top">
                                <i [ngClass]="selectedFileName ? 'pi pi-file-pdf' : 'pi pi-plus-circle'"></i>
                                <span>{{ selectedFileName || "Subir un archivo" }}</span>
                            </div>

                            <p-divider *ngIf="!selectedFileName" align="center" type="solid">o</p-divider>

                            <span *ngIf="!selectedFileName">Arrástralo aquí</span>
                        </div>
                    </div>
                </div>

                <div style="color: grey; font-size: 0.75rem; text-align: center; display: flex; flex-direction: column;">
                    <p style="padding: 0; margin: 0">Formatos admitidos: pdf. Tamaño máximo de archivo: 10 MB.</p>
                </div>

                <p-fileUpload
                    #pdfUploader
                    [accept]="'application/pdf'"
                    [maxFileSize]="10000000"
                    (onSelect)="onChangeFile($event)"
                    [style]="{ display: 'none' }"
                ></p-fileUpload>
            </div>
        </div>
    </div>

    <div
        *ngIf="!isLoading"
        style="display: inline-flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-top: auto; padding: 16px 24px; box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.08);"
    >
        <button
            type="button"
            pButton
            (click)="onBack()"
            label="Atrás"
            class="btn btn-atras"
        ></button>

        <div style="display: inline-flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-left: auto;">
            <button
                type="button"
                pButton
                label="Cancelar"
                class="btn btn-default"
                (click)="closeDialog()"
            >
            </button>

            <button
                type="button"
                pButton
                label="Guardar cambios"
                class="btn btn-solid"
                [disabled]="isDisabledContract"
                (click)="onSaveChanges()"
            >
            </button>
        </div>
    </div>
</p-dialog>